import level1 from "@/assets/images/achievements/hapi-hero/level-1.webp";
import { T_ME_HAPI_ANN } from "@/constants";
import { ButtonActionMap } from "@/services/config/translation";
import { colors } from "@/theme/colors";

export const hapiHeroAdditionalComponents: Record<
  number,
  {
    background: string;
    image: string;
    action: {
      title: ButtonActionMap;
      handler: () => void;
    };
  }
> = {
  1: {
    background: colors.blackTertiary,
    image: level1,
    action: {
      title: "Subscribe",
      handler: () => window.open(T_ME_HAPI_ANN),
    },
  },
};
